// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__KkADQ","row":"styles_row__1uZs_"};